export default "__VITE_ASSET__da9dcc6a__"